// extracted by mini-css-extract-plugin
export default {"profileTab":"ProfileTab_profileTab__Obuvv"};